import { useContext } from 'react';
import { isEmpty } from 'lodash';
import {
    FEATURE_FLAGS,
    useAccount,
    useAccountConfig,
} from 'modules/taboola-common-frontend-modules/account-configurations';
import { isUserPermissionOrFeatureFlagEnabled } from 'modules/taboola-common-frontend-modules/account-configurations/utils/isUserPermissionOrFeatureFlagEnabled';
import PermissionsContext from 'modules/taboola-common-frontend-modules/authentication/PermissionsContext';

const allFeatureFlags = Object.values(FEATURE_FLAGS);

export const checkPixelLookalikePermitted = ({ permissions, selectedAccountConfig, selectedAccount }) => {
    const isPermitted = isUserPermissionOrFeatureFlagEnabled(
        permissions,
        selectedAccountConfig,
        'CREATE_PIXEL_PREDICTIVE',
        FEATURE_FLAGS.PIXEL_PREDICTIVE_ENABLED
    );

    const rawExcludedCustomerProfiles =
        selectedAccountConfig?.[FEATURE_FLAGS.CREATE_PBP_EXCLUDED_CUSTOMER_PROFILES_LIST];
    let excludedCustomerProfiles = new Set();
    try {
        excludedCustomerProfiles = new Set((rawExcludedCustomerProfiles || '')?.split(','));
    } catch (error) {
        console.error('Error splitting excluded customer profiles', error);
    }

    const advertiserType = selectedAccount?.advertiserType;
    const associatedAccountAdvertiserTypes = selectedAccount?.associatedAccountAdvertiserTypes;

    const hasValidAdvertiserType = !excludedCustomerProfiles.has(advertiserType);
    const hasValidAssociatedAccountAdvertiserTypes =
        isEmpty(associatedAccountAdvertiserTypes) ||
        associatedAccountAdvertiserTypes.some(advertiserType => !excludedCustomerProfiles.has(advertiserType));

    return Boolean(isPermitted && hasValidAdvertiserType && hasValidAssociatedAccountAdvertiserTypes);
};

export const usePixelLookalikePermitted = () => {
    const permissions = useContext(PermissionsContext);
    const selectedAccountConfig = useAccountConfig(allFeatureFlags);
    const selectedAccount = useAccount();

    return checkPixelLookalikePermitted({ permissions, selectedAccountConfig, selectedAccount });
};
